import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { DatePicker } from '@components';
import { formatCurrency } from '../../utils/helpers';

interface BookingSectionProps {
  pricePerDay: number;
  available: boolean;
  totalDays: number;
  onDateChange: (start: Date | null, end: Date | null) => void;
  equipment?: {
    id: string;
    name: string;
    images: Array<{ url: string }>;
  };
  startDate?: Date | null;
  endDate?: Date | null;
}

export const BookingSection: React.FC<BookingSectionProps> = ({
  pricePerDay,
  available,
  totalDays,
  onDateChange,
  equipment,
  startDate,
  endDate,
}) => {
  const navigate = useNavigate();

  const handleReservation = () => {
    if (!equipment || !startDate || !endDate || totalDays === 0) {
      return;
    }

    const totalPrice = pricePerDay * totalDays;
    
    navigate(`/equipment/${equipment.id}/reserve`, {
      state: {
        equipment: {
          id: equipment.id,
          name: equipment.name,
          price: pricePerDay,
          images: equipment.images.map(img => img.url),
        },
        dates: {
          startDate,
          endDate,
        },
        totalPrice,
      }
    });
  };
  return (
    <div className="sticky top-24 bg-white rounded-xl border border-gray-200 shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800">
          {formatCurrency(pricePerDay)}<span className="text-gray-500 font-normal text-base"> / día</span>
        </h2>
        <div className="flex items-center">
          <Star size={16} className="text-yellow-400 fill-yellow-400 mr-1" />
          <span>5</span>
        </div>
      </div>
      <div className="mb-6">
        <DatePicker onDateChange={onDateChange} />
      </div>
      {totalDays > 0 && (
        <div className="border-t border-gray-200 pt-4 mb-4">
          <div className="flex justify-between mb-2">
            <span>{formatCurrency(pricePerDay)} x {totalDays} días</span>
            <span>{formatCurrency(pricePerDay * totalDays)}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span>Comisión de servicio</span>
            <span>{formatCurrency(Math.round(pricePerDay * totalDays * 0.1))}</span>
          </div>
          <div className="border-t border-gray-200 pt-2 mt-2 flex justify-between font-bold">
            <span>Total</span>
            <span>{formatCurrency(pricePerDay * totalDays + Math.round(pricePerDay * totalDays * 0.1))}</span>
          </div>
        </div>
      )}
      <button
        onClick={handleReservation}
        className={`w-full py-3 rounded-lg font-medium ${totalDays > 0 && available
          ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
          : 'bg-gray-200 text-gray-500 cursor-not-allowed'
          }`}
        disabled={totalDays === 0 || !available}
      >
        {!available
          ? 'No disponible actualmente'
          : totalDays === 0
            ? 'Selecciona fechas para reservar'
            : 'Reservar equipo'
        }
      </button>
      {available && (
        <p className="text-center text-sm text-gray-500 mt-2">
          No se te cobrará todavía
        </p>
      )}
    </div>
  );
};
